{
  "success": {
    "analyses/setMovable": "Analýza aktualizována",
    "analyses/moveIntoPlan": "Analýza úspěšně přesunuta do plánu",
    "analyses/remove": "Analýza úspěšně odplánována",
    "analysisDefinitions/create": "Přidána nová definice analýzy",
    "analysisDefinitions/edit": "Definice analýzy upravena",
    "analysisDefinitions/remove": "Definice analýzy smazána",
    "analysisDraft/create": "Přidán nový návrh analýzy",
    "analysisDraft/edit": "Návrh analýzy upraven",
    "samples/delete-unlocked": "Všechny nenaplánované vzorky smazány",
    "assets/remove": "Přístroj úspěšně smazán",
    "assets/create": "Přidán nový přístroj",
    "assets/edit": "Přístroj upraven",
    "competenceGroups/create": "Nová skupina kompetencí úspěšně vytvořena",
    "competenceGroups/edit": "Skupina kompetencí úspěšně upravena",
    "competenceGroups/remove": "Skupina kompetencí úspěšně smazána",
    "iap/run": "IAP úspěšně spuštěn",
    "iap/runFillInSamples": "Vzorky úspěšně vyplněny",
    "integrationSheets/createActionSheet": "List přidán",
    "integrationSheets/createProjectTemplateSheets": "List přidán",
    "integrationSheets/createSampleSheet": "List přidán",
    "integrationSheets/editActionSheet": "List upraven",
    "integrationSheets/editProjectTemplateSheet": "List upraven",
    "integrationSheets/editSampleSheet": "List upraven",
    "integrationSheets/removeActionSheet": "List smazán",
    "integrationSheets/removeProjectTemplateSheet": "List smazán",
    "integrationSheets/removeSampleSheet": "List smazán",
    "integrationSheets/saveSapConversionSheet": "List importu projektu uložen",
    "members/create": "Člen přidán",
    "members/createAsAdmin": "Člen přidán",
    "members/edit": "Člen upraven",
    "members/archive": "Člen archivován",
    "projectActions/editPlanned": "Akce projektu upravena",
    "projectActions/move": "Akce projektu zařazena do plánu",
    "projectActions/setMovable": "Akce projektu aktualizována",
    "projectActions/setLocation": "Místo aktualizováno",
    "projectActions/setLocationUnplanned": "Místo aktualizováno",
    "projectActions/editUnplanned": "Nenaplánovaná akce projektu upravena",
    "projectActions/removePlanned": "Projekt odplánován",
    "projects/create": "Přidán nový projekt",
    "projects/edit": "Projekt aktualizován",
    "projects/remove": "Projekt smazán",
    "projects/delete-unplanned": "Všechny nenaplánované projekty smazány",
    "projects/lockProject": "Projekt uzamčen",
    "projects/unlockProject": "Projekt odemčen",
    "projectTemplates/create": "Nová šablona projektu vytvořena",
    "projectTemplates/createDraft": "Nový návrh šablony projektu vytvořen",
    "projectTemplates/edit": "Šablona projektu upravena",
    "projectTemplates/editDraft": "Návrh šablony projektu upraven",
    "projectTemplates/remove": "Šablona projektu smazána",
    "whiteTasks/remove": "Úkol úspěšně smazán",
    "whiteTasks/create": "Přidán nový úkol",
    "whiteTasks/edit": "Úkol úspěšně upraven",
    "whiteTasks/createRecurrence": "Opakování vytvořeno",
    "whiteTasks/removeRecurrence": "Opakující se úkoly odstraněny",
    "teamStatus/start": "Simulační režim aktivován",
    "teamStatus/accept": "Změny simulačního režimu aplikovány",
    "teamStatus/discard": "Změny simulačního režimu zahozeny",
    "customers/addCustomer": "Zákazník přidán",
    "customers/editCustomer": "Zákazník upraven",
    "customers/deleteCustomer": "Zákazník smazán",
    "team/create-api-token": "Token API vytvořen",
    "team/delete-api-token": "Token API smazán"
  },
  "error": {
    "analyses/remove/ERROR": "Odplánování analýzy selhalo",
    "analysisDefinitions/create/ERROR": "Přidání nové definice analýzy selhalo",
    "analysisDefinitions/remove/ERROR": "Smazání definice analýzy selhalo",
    "assets/remove/ERROR": "Smazání přístroje selhalo",
    "assets/create/ERROR": "Přidání přístroje selhalo",
    "auth/login/ERROR": "Přihlášení selhalo",
    "competenceGroups/create/ERROR": "Vytvoření skupiny kompetencí selhalo",
    "competenceGroups/remove/ERROR": "Smazání skupiny kompetencí selhalo",
    "iap/run/ERROR": "Spuštění IAP selhalo",
    "iap/runFillInSamples/ERROR": "Vyplnění vzorků selhalo",
    "integrationSheets/createActionSheet/ERROR": "Přidání listu selhalo",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Přidání listu selhalo",
    "integrationSheets/createSampleSheet/ERROR": "Přidání listu selhalo",
    "integrationSheets/editActionSheet/ERROR": "Úprava listu selhala",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Úprava listu selhala",
    "integrationSheets/editSampleSheet/ERROR": "Úprava listu selhala",
    "integrationSheets/removeActionSheet/ERROR": "Při pokusu o smazání listu došlo k chybě",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Při pokusu o smazání listu došlo k chybě",
    "integrationSheets/removeSampleSheet/ERROR": "Při pokusu o smazání listu došlo k chybě",
    "loading/fetchAll/ERROR": "Načítání selhalo",
    "members/create/ERROR": "Přidání člena selhalo",
    "members/createAsAdmin/ERROR": "Přidání člena selhalo",
    "members/archive/ERROR": "Archivace člena selhala",
    "projectActions/move/ERROR": "Přesun akce do plánu selhal",
    "projectActions/removePlanned/ERROR": "Odplánování akce selhalo",
    "projectActions/setLocation/ERROR": "Aktualizace místa selhala",
    "projectActions/setLocationUnplanned/ERROR": "Aktualizace místa selhala",
    "projects/create/ERROR": "Přidání nového projektu selhalo",
    "projects/remove/ERROR": "Smazání projektu selhalo",
    "projects/delete-unplanned/ERROR": "Smazání nenaplánovaných projektů selhalo",
    "projects/lockProject/ERROR": "Uzamčení akcí selhalo",
    "projectTemplates/create/ERROR": "Vytvoření nové šablony projektu selhalo",
    "projectTemplates/createDraft/ERROR": "Vytvoření nového návrhu šablony projektu selhalo",
    "projectTemplates/remove/ERROR": "Smazání šablony projektu selhalo",
    "whiteTasks/remove/ERROR": "Smazání úkolu selhalo",
    "whiteTasks/create/ERROR": "Vytvoření selhalo",
    "teamStatus/start/ERROR": "Aktivace simulačního režimu selhala",
    "teamStatus/accept/ERROR": "Aplikování změn simulačního režimu selhalo",
    "teamStatus/discard/ERROR": "Zahození změn simulačního režimu selhalo",
    "customers/deleteCustomer/ERROR": "Zákazníka se nepodařilo smazat",
    "customers/addCustomer/ERROR": "Zákazníka se nepodařilo přidat",
    "customers/editCustomer/ERROR": "Zákazníka se nepodařilo upravit",
    "team/create-api-token/ERROR": "Token API se nepodařilo vytvořit",
    "team/delete-api-token/ERROR": "Token API se nepodařilo smazat"
  },
  "adhoc": {
    "welcomeBack": "Vítejte zpět!",
    "noSoundDetected": "Žádný zvuk nebyl zjištěn. Zkuste to prosím znovu.",
    "noMicrophoneDetected": "Žádný mikrofon nebyl zjištěn. Zkuste to prosím znovu.",
    "iapRunning": "Chvilku počkejte – IAP pro váš tým právě běží",
    "failedDiscardNotLoggedOut": "Zahození změn selhalo. Nebyli jste odhlášeni!",
    "cannotDragRecurrentTask": "Opakující se šedý úkol nelze přetáhnout",
    "cannotMoveImportedTasks": "Importované úkoly nelze přesunout",
    "noCheckboxesSelected": "Nejsou zaškrtnuta žádná políčka",
    "analysisUpdatedRefresh": "Analýza aktualizována, obnovte prosím stránku",
    "analysisUpdatedByAnotherUser": "Analýza byla aktualizována jiným uživatelem, obnovte prosím stránku",
    "copiedToClipboard": "Zkopírováno do schránky",
    "couldNotCopyToClipboard": "Kopírování do schránky selhalo",
    "chooseFirstAction": "Vyberte prosím první {{itemType}}",
    "chooseSecondAction": "Vyberte prosím druhý {{itemType}}",
    "chooseTwoDifferent": "Vyberte prosím dva různé {{itemType}}",
    "constraintConflicts": "Toto omezení je v konfliktu s existujícími omezeními",
    "sampleCreated": "Vzorek vytvořen",
    "sampleDeleted": "Vzorek smazán",
    "samplesUpdated": "Vzorky aktualizovány",
    "sampleMarkedDone": "Vzorek označen jako hotový",
    "memberPermissionsChanged": "Oprávnění člena změněna",
    "chooseUniqueName": "Zvolte prosím jedinečný název",
    "fillRequiredFields": "Vyplňte prosím požadovaná pole",
    "couldNotDetermineSampleIdDone": "Nepodařilo se určit ID vzorku pro označení jako hotového",
    "couldNotDetermineSampleIdDelete": "Nepodařilo se určit ID vzorku pro smazání",
    "couldNotDetermineSampleIdDeleteMissing": "Nepodařilo se určit ID vzorku pro smazání – chybí data. Podrobnosti najdete v konzoli.",
    "anErrorOccurred": "Došlo k chybě",
    "selectFileBeforeSubmitting": "Před odesláním vyberte alespoň jeden soubor",
    "helpPageUpdated": "Stránka nápovědy aktualizována",
    "processingStarted": "Zpracování zahájeno",
    "failedLoadingIcalFiles": "Načítání souborů iCalendar selhalo",
    "unsortBeforePasting": "Před vložením více buněk prosím zrušte řazení tabulky.",
    "fillAllRequiredFields": "Vyplňte prosím všechna požadovaná pole",
    "unsavedChangesConfirmLeave": "Máte neuložené změny. Pro potvrzení odchodu stiskněte tlačítko zpět znovu.",
    "provideSheetName": "Zadejte prosím název listu",
    "sheetNameAlreadyExists": "List s tímto názvem již existuje",
    "provideSheetType": "Zadejte prosím typ listu",
    "didNotSpellDeleteProperly": "Nezadali jste správně SMAZAT",
    "domainMustStartWithAt": "Doména musí začínat znakem '@'",
    "fillOutRequiredFields": "Vyplňte prosím požadovaná pole",
    "selectValidDates": "Vyberte prosím platná data",
    "noIapModeSelected": "Není vybrán žádný režim IAP. Vyberte prosím režim.",
    "oneCollaboratorForWorkday": "Při zaškrtnutí celého pracovního dne lze vybrat pouze jednoho spolupracovníka",
    "fillRequiredDateTimeFields": "Vyplňte prosím všechna požadovaná pole data a času",
    "endMustBeAfterStart": "Konec úkolu musí být po začátku",
    "recurrencesCannotExceed365": "Počet opakování nesmí překročit 365",
    "pleaseFillNumberAndInterval": "Vyplňte prosím počet a interval opakování",
    "pleaseFillNumberOfRecurrences": "Vyplňte prosím počet opakování",
    "pleaseFillIntervalOfRecurrences": "Vyplňte prosím interval opakování",
    "pleaseFillAllPeriodFields": "Vyplňte prosím všechna pole období",
    "pleaseSelectReportType": "Vyberte prosím alespoň jeden typ sestavy",
    "reportEmptyInInterval": "Soubor {{fileName}} je v zadaném intervalu prázdný",
    "noSoundDetected": "Žádný zvuk nebyl zjištěn. Zkuste to prosím znovu.",
    "noMicrophoneDetected": "Žádný mikrofon nebyl zjištěn. Zkuste to prosím znovu.",
    "promptTooLong": "Prompt je příliš dlouhý (max. 1200 znaků)",
    "nameTooLong": "Název je příliš dlouhý (max. 100 znaků)"
  }
}
